import base_ds, {CrudOperates} from '@/services/base_datasource_service'
import DataSource from 'devextreme/data/data_source';
import {AxiosResponse} from "axios";
import {IResponseResult} from "@/services/data/base_types";

export const route_ns = 'service_monitoring';
export const hardware_route_ns = 'hardware_monitoring';


export const SocketChannels = {
  service_status: "service_status",
  hardware_metrics: "hardware_metrics",
  hardware_alarm: "hardware_alarm",
};

export class Monitoring {
  id: string | null = null
  name: string = ''
  description: string | null = null
  status: number = 0
}

export class HardwareMonitoring {
  id?: string;
  date_created?: string | Date | null;
  date_modified?: string | Date | null;
  created_by_id?: string | null;
  modified_by_id?: string | null;
  cpu_usage: number | null = null // 'загрузка процессора %'
  cpu_temp: number | null = null // температура процессора, град'
  free_memory: number | null = null // свободно оперативной памяти, %')
  free_disk: number | null = null // свободно места на диске, %')
  extra?: any // дополнительные показатели
}

class entityClass extends Monitoring {}

class MonitoringsService {
  dataSource: DataSource;
  crud: CrudOperates;
  hardware_crud: CrudOperates;
  gateway_unavailable: boolean;

  public selected_row: any = null;

  public edit_popup: any = {
    visible: false,
    edit_mode: false,
  }

  constructor() {
    this.dataSource = base_ds.getBaseDataSource(route_ns);
    this.crud = base_ds.getBaseCrud(route_ns);

    this.hardware_crud = base_ds.getBaseCrud(hardware_route_ns);

    this.gateway_unavailable = false;
  }

  public async getHardwareMonitoring(): Promise<IResponseResult<HardwareMonitoring[]>> {
    const response: AxiosResponse['data'] = await this.hardware_crud.get();

    if (response && Array.isArray(response.data)) {
      return {data: (response.data as HardwareMonitoring[])};
    } else if (response && response.message) {
      return {data: null, message: response.message};
    }
    return {data: null, message: ''};
  }

  public async getGatewayStatus(): Promise<void> {
    try {
      const response: AxiosResponse['data'] = await this.crud.get_by_id('gateway');
      // Шлюз доступен если response.gateway_status = true
      this.gateway_unavailable = !response?.gateway_status;
    } catch (e) {
      this.gateway_unavailable = true;
    }
  }

  async post(action: string, entity: entityClass, timeout: number) {
    return this.crud.post(action + '/' + String(entity.id), entity, timeout);
  }

  async save(entity: entityClass) {
    return this.crud.save(entity);
  }

  async delete(entity: entityClass) {
    return this.crud.delete(entity.id);
  }

  setEditPopupVisible(vis: boolean) {
    this.edit_popup.visible = vis;
  }

  setEditPopupMode(vis: boolean) {
    this.edit_popup.edit_mode = vis;
  }

  setCurrentRow(data: entityClass | null) {
    this.selected_row = data;
  }
}

export default new MonitoringsService();
